import gql from "graphql-tag";

export const GET_PROJECTS = gql`
  query ($input: getProjectsInput) {
    getProjects(input: $input) {
      data {
        _id
        created_at
        updated_at
        description
        title
        total_time
        total_activities
        total_members
        color
        status
        client {
          _id
          full_name
          email
        }
        manager {
          _id
          email
          full_name
          avatar
        }
        created_by {
          _id
          email
          full_name
          avatar
          addons {
            _id
            name
            cost
            currency
          }
          plan {
            _id
            name
          }
        }
        members {
          _id
          email
          full_name
          avatar
        }
      }
      pagination {
        total_data
        current_page
        total_pages
      }
    }
  }
`;
